<template>
  <div></div>
</template>

<script>
export default {
  mounted () {
    this.$router.replace('/Dashboard')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue